import React from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { WebRoutes } from "../../../../Constants";

import "./NoRolePage.scss";

export function NoRolePage() {
  const [t] = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="no-role-page trans-fromTop">
      <span className="title">{t("UserHasNoRole")}</span>
      <span className="description">{t("UserHasNoRoleDescription")}</span>
      <Button className="button" onClick={() => navigate(WebRoutes.Logout)}>
        {t("ProfilePageLogOut")}
      </Button>
    </div>
  );
}
